// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"88":"131b526e","552":"eb3e63f8"}[chunkId] + ".js";
};